<template>
  <section class="saved-scenarios">
    <section class="panel panel-default">
      <section class="panel-heading">
        <h3 class="panel-title">
          Saved scenarios
          <a href="/quick-guide#quick-guide-save-scenarios"><small>What is this?</small></a>
        </h3>
      </section>
      <section class="panel-body">
        <section v-if="purchasedShortDeck && savedScenarios.shortDeckEquityCalculator.length > 0">
          <span>Short deck equity calculator:</span>
          <saved-scenarios-for-tool
            v-bind:savedScenarios="savedScenarios"
            v-bind:tool="'shortDeckEquityCalculator'"
          />
        </section>
        <section v-if="purchasedShortDeck && savedScenarios.shortDeckHitCalculator.length > 0">
          <span>Short deck hit calculator:</span>
          <saved-scenarios-for-tool
            v-bind:savedScenarios="savedScenarios"
            v-bind:tool="'shortDeckHitCalculator'"
          />
        </section>
        <section v-if="savedScenarios.equityCalculator.length > 0">
          <span>Equity calculator:</span>
          <saved-scenarios-for-tool
            v-bind:savedScenarios="savedScenarios"
            v-bind:tool="'equityCalculator'"
          />
        </section>
        <section v-if="savedScenarios.hitCalculator.length > 0">
          <span>Hit calculator:</span>
          <saved-scenarios-for-tool
            v-bind:savedScenarios="savedScenarios"
            v-bind:tool="'hitCalculator'"
          />
        </section>
        <section v-if="savedScenarios.equityMatrix.length > 0">
          <span>Equity matrix:</span>
          <saved-scenarios-for-tool
            v-bind:savedScenarios="savedScenarios"
            v-bind:tool="'equityMatrix'"
          />
        </section>
        <section v-if="savedScenarios.rangeConstructor.length > 0">
          <span>Range constructor:</span>
          <saved-scenarios-for-tool
            v-bind:savedScenarios="savedScenarios"
            v-bind:tool="'rangeConstructor'"
          />
        </section>
        <section v-if="savedScenarios.shouldYouBluff.length > 0">
          <span>Should you bluff:</span>
          <saved-scenarios-for-tool
            v-bind:savedScenarios="savedScenarios"
            v-bind:tool="'shouldYouBluff'"
          />
        </section>
        <section v-if="savedScenarios.shouldYouCall.length > 0">
          <span>Should you call:</span>
          <saved-scenarios-for-tool
            v-bind:savedScenarios="savedScenarios"
            v-bind:tool="'shouldYouCall'"
          />
        </section>
        <section v-if="savedScenarios.turnBluffBreakevenPercentage.length > 0">
          <span>Breakeven percentage for bluffing the turn:</span>
          <saved-scenarios-for-tool
            v-bind:savedScenarios="savedScenarios"
            v-bind:tool="'turnBluffBreakevenPercentage'"
          />
        </section>
        <section v-if="savedScenarios.threeBetCbetExplorer.length > 0">
          <span>3bet-cbet explorer:</span>
          <saved-scenarios-for-tool
            v-bind:savedScenarios="savedScenarios"
            v-bind:tool="'threeBetCbetExplorer'"
          />
        </section>
        <hr v-if="pagesWithNoSavedScenarios.length > 0 && pagesWithNoSavedScenarios.length < 8">
        <p v-if="pagesWithNoSavedScenarios.length > 0">{{ noSavedScenariosText }}</p>
      </section>
    </section>
  </section>
</template>

<script>
import SavedScenariosForTool from '@/components/user/saved-scenarios-for-tool';
import _ from 'lodash';

export default {
  name: 'saved-scenarios',
  props: ['savedScenarios'],
  components: {
    'saved-scenarios-for-tool': SavedScenariosForTool,
  },
  computed: {
    purchasedShortDeck: function () {
      return this.$store.state.account.user.auth.includes('short deck');
    },
    pagesWithNoSavedScenarios: function () {
      let pagesWithNoSavedScenarios = [];

      if (this.purchasedShortDeck && this.savedScenarios.shortDeckEquityCalculator.length === 0) {
        pagesWithNoSavedScenarios.push('short deck equity calculator');
      }

      if (this.purchasedShortDeck && this.savedScenarios.shortDeckHitCalculator.length === 0) {
        pagesWithNoSavedScenarios.push('short deck hit calculator');
      }

      if (this.savedScenarios.equityCalculator.length === 0) {
        pagesWithNoSavedScenarios.push('equity calculator');
      }

      if (this.savedScenarios.hitCalculator.length === 0) {
        pagesWithNoSavedScenarios.push('hit calculator');
      }

      if (this.savedScenarios.equityMatrix.length === 0) {
        pagesWithNoSavedScenarios.push('equity matrix');
      }

      if (this.savedScenarios.rangeConstructor.length === 0) {
        pagesWithNoSavedScenarios.push('range constructor');
      }

      if (this.savedScenarios.shouldYouBluff.length === 0) {
        pagesWithNoSavedScenarios.push('should you bluff');
      }

      if (this.savedScenarios.shouldYouCall.length === 0) {
        pagesWithNoSavedScenarios.push('should you call');
      }

      if (this.savedScenarios.turnBluffBreakevenPercentage.length === 0) {
        pagesWithNoSavedScenarios.push('bluffing the turn breakeven percentage');
      }

      if (this.savedScenarios.threeBetCbetExplorer.length === 0) {
        pagesWithNoSavedScenarios.push('3bet-cbet explorer');
      }

      return pagesWithNoSavedScenarios;
    },
    noSavedScenariosText: function () {
      let i;
      let noSavedScenariosText = 'The following pages don\'t have any saved scenarios: ';

      if ((!this.purchasedShortDeck && this.pagesWithNoSavedScenarios.length === 8) || (this.purchasedShortDeck && this.pagesWithNoSavedScenarios.length === 10)) {
        return 'You haven\'t saved any scenarios.';
      }

      if (this.pagesWithNoSavedScenarios.length === 1) {
        noSavedScenariosText += this.pagesWithNoSavedScenarios[0] + '.';
        return noSavedScenariosText;
      }

      for (i = 0; i < this.pagesWithNoSavedScenarios.length - 1; i++) {
        noSavedScenariosText += this.pagesWithNoSavedScenarios[i] + ', ';
      }

      noSavedScenariosText += 'and ' + this.pagesWithNoSavedScenarios[i] + '.';
      return noSavedScenariosText;
    },
  },
};
</script>

<style lang="scss" scoped>
  .panel-title {
    font-size: 18px;
  }

  .panel-heading {
    padding: 15px 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/saved-scenarios.vue